import api from "lib/api/api";
import { persistor } from "../Store";
import {
  CLEAR_SESSION_EXPIRED,
  GET_ERRORS,
  LOGIN_FAILURE,
  LOGOUT,
  SET_CURRENT_USER,
} from "./types";

export const loginUser = (userData, navigate) => async (dispatch) => {
  try {
    const res = await api.post(`/users/login`, userData, {
      withCredentials: true,
    });

    const {
      profileName,
      userId,
      roleName,
      roleNames,
      studentId,
      cookieConsentAccepted,
    } = res.data;

    localStorage.setItem("profileName", profileName);
    localStorage.setItem("userId", userId);
    localStorage.setItem("roleName", roleName);
    localStorage.setItem("roleNames", JSON.stringify(roleNames));
    localStorage.setItem("cookieConsentAccepted", String(Boolean(cookieConsentAccepted)));

    const userPayload = {
      profileName,
      userId,
      roleName,
      roleNames,
      studentId,
      cookieConsentAccepted: Boolean(cookieConsentAccepted),
    };
    dispatch(setCurrentUser(userPayload));
    navigate("/");
  } catch (err) {
    console.error("Login error:", err);
    dispatch({
      type: GET_ERRORS,
      payload: err.response ? err.response.data : { message: "Server Error" },
    });
    dispatch({
      type: LOGIN_FAILURE,
    });
    throw err;
  }
};

export const setCurrentUser = (data) => {
  return {
    type: SET_CURRENT_USER,
    payload: data,
  };
};

export const logoutUser = (noNavigate) => async (dispatch) => {
  try {
    await api.post(`/users/logout`, {}, { withCredentials: true });
  } catch (err) {
    console.error("Logout failed", err);
  } finally {
    dispatch({
      type: LOGOUT,
    });
    dispatch({ type: CLEAR_SESSION_EXPIRED });
    const cookieConsent = localStorage.getItem("algermanist_cookie_consent_v1");
    const i18nLanguage = localStorage.getItem("i18nextLng");
    localStorage.clear();
    if (cookieConsent) localStorage.setItem("algermanist_cookie_consent_v1", cookieConsent);
    if (i18nLanguage) localStorage.setItem("i18nextLng", i18nLanguage);
    persistor.purge();

    if (!noNavigate) window.location.href = "/login";
  }
};
export const checkSession = () => async (dispatch, getState) => {
  const { sessionChecked } = getState().auth;

  if (sessionChecked) return;

  dispatch({ type: "SESSION_CHECK_START" });

  try {
    await api.get("/auth/validate");
    dispatch({ type: "SESSION_OK" });
  } catch (err) {
    if (err.response?.status === 403) {
      dispatch({ type: "SESSION_EXPIRED" });
    } else {
      dispatch({ type: "SESSION_EXPIRED" });
    }
  }
};
